import { CircularProgress, Tooltip } from "@octopusdeploy/design-system-components";
import { ExclamationTriangleIcon } from "@octopusdeploy/design-system-icons";
import { themeTokens } from "@octopusdeploy/design-system-tokens";
import * as React from "react";
interface MissingVariablesIcon {
    show: boolean;
    withoutTooltip?: boolean;
    isLoading?: boolean;
}
const MissingVariablesIcon: React.FC<MissingVariablesIcon> = (props) => {
    const AlertIcon = () => <ExclamationTriangleIcon size={24} color={themeTokens.color.icon.warning}/>;
    const LoadingIcon = () => <CircularProgress size="small" aria-label="Checking for missing variables"/>;
    if (props.isLoading) {
        if (props.withoutTooltip) {
            return <LoadingIcon />;
        }
        return (<Tooltip content="Checking for missing variables...">
                <LoadingIcon />
            </Tooltip>);
    }
    if (!props.show) {
        return null;
    }
    if (props.withoutTooltip) {
        return <AlertIcon />;
    }
    return (<Tooltip content={`Some of the required variable values have not been set`}>
            <AlertIcon />
        </Tooltip>);
};
MissingVariablesIcon.displayName = "MissingVariablesIcon"
export default MissingVariablesIcon;
